module.exports = __webpack_public_path__ + "img/logo.6b5a024a.svg";